// Shared CLASS renderer for the call strips (Quick Snapshot + the shared callbar). Resolves the rep's
// class server-side (by the real rep_key, robust to display-name edits) and paints it as two lines —
// the class name (or "Pending assignment") on top, an "(assign on Teams)" link beneath. Kept narrow so
// it doesn't squeeze the Call Details column into wrapping. Hidden until a call is loaded, and hidden
// entirely if classes can't be read (no team access).

import * as api from '../lib/api.js';
import { navigateTo } from './sidenav.js';

export interface RepClassState {
  hasCall: boolean; // a call is loaded (session present)
  scored: boolean; // Run finished — the rep is known
  repName: string | null;
}

function fill(val: HTMLElement, className: string | null): void {
  val.textContent = '';
  const line1 = document.createElement('div');
  line1.textContent = className ?? 'Pending assignment';
  if (className) line1.className = 'sk-class-name';
  const line2 = document.createElement('div');
  const link = document.createElement('a');
  link.href = '#';
  link.className = 'sk-class-link';
  link.textContent = '(assign on Teams)';
  link.addEventListener('click', (e) => { e.preventDefault(); navigateTo('teams'); });
  line2.appendChild(link);
  val.appendChild(line1);
  val.appendChild(line2);
}

/** Paint the CLASS block. `box` is the container (toggled hidden), `val` its value node. */
export function paintRepClass(box: HTMLElement | null, val: HTMLElement | null, st: RepClassState): void {
  if (!box || !val) return;
  if (!st.hasCall) { box.hidden = true; return; }
  box.hidden = false;
  const seq = String((Number(box.dataset.cseq ?? '0') + 1) % 1_000_000);
  box.dataset.cseq = seq; // drop a stale response if the call changes mid-flight
  if (!st.scored || !st.repName) { val.textContent = '—'; return; }
  val.textContent = '…';
  api
    .getRepClass(st.repName)
    .then((res) => { if (box.dataset.cseq === seq) fill(val, res.className); })
    .catch(() => { if (box.dataset.cseq === seq) box.hidden = true; }); // no access → no CLASS block
}
